import { Box, Button, Icon, Text } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

const BlankState = () => {
  const { navigation } = useNavigation()

  return (
    <Box paddingTop="s96" paddingBottom="s120" gap="s16" alignItems="center">
      <Icon.Large icon="love-hands" />
      <Text.Header2>{i18n.t('enps.answer.title_settings')}</Text.Header2>
      <Text.Normal>{i18n.t('enps.answer.description_settings')}</Text.Normal>
      <Button.Router type="primary" to={navigation.engagement.enps.configuration.fullPath()}>
        {i18n.t('enps.answer.button_settings')}
      </Button.Router>
    </Box>
  )
}
export default BlankState
